import * as React from 'react';
import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { getVideoMessage } from '../firestore';
import { OrderVideoMessage } from '../model/ClientModels';
import styled from 'styled-components';

// Import it from model will cause issue with unexpected token?
enum OrderVideoReviewEmoji {
  RollingEyesFace = 'rolling_eyes_face',
  Sweat = 'sweat',
  Blush = 'blush',
  Smile = 'smile',
  HeartEyes = 'heart_eyes'
}

const Video = styled('video')`
  width: 67%;
  display: flex;
  border-radius: 13px;
  overflow: hidden;
  flex-shrink: 0;
`;

const Container = styled.div`
  background-color: #222222;
  height: 100%;
`;

const Content = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  margin: 0 auto;
  max-width: 500px;
  min-width: 320px;
  align-items: center;
  padding: 52px 16px 40px;
  overflow: auto;
`;

const Title = styled.div`
  font-size: 40px;
  color: #e4ff5f;
  text-align: center;
  line-height: 45px;
  margin-bottom: 15px;
`;

const Reaction = (props: { emoji: OrderVideoReviewEmoji }) => (
  <Reaction.Container>
    <Reaction.Content>
      <Reaction.Image src={imageFor(props.emoji)} />
      <Reaction.Title>Reaction</Reaction.Title>
    </Reaction.Content>
  </Reaction.Container>
);

Reaction.Title = styled.div`
  font-family: Montserrat-Bold, serif;
  font-size: 10px;
  color: #ffd635;
`;

Reaction.Image = styled.img`
  width: 26px;
  height: 26px;
  object-fit: contain;
  object-position: center;
  margin-right: 6px;
`;

Reaction.Content = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
  border-radius: 15px;
  padding: 0 18px 0 3px;
  background: rgba(0, 0, 0, 0.25);
`;

Reaction.Container = styled.div`
  display: flex;
  margin-top: -42px;
  margin-bottom: 48px;
  width: 63%;
  z-index: 1;
`;

const Note = styled.div`
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  line-height: 23px;
`;

const Spacer = styled.div`
  flex: 1;
  min-height: 30px;
`;

const BottomRow = () => (
  <BottomRow.Container>
    <BottomRow.Logo />
    <BottomRow.Texts>
      POPSHOP LIVE
      <br />
      SHOP, SELL, STREAM!
    </BottomRow.Texts>
    <a href="https://itunes.apple.com/us/app/popshop-start-shopping-us/id1009480270?ls=1&mt=8">
      <BottomRow.AppStore />
    </a>
  </BottomRow.Container>
);

BottomRow.Logo = styled.img.attrs({
  src: require('./assets/Logos.png'),
  alt: 'Logo'
})`
  width: 36px;
  height: 36px;
`;

BottomRow.AppStore = styled.img.attrs({
  src: require('./assets/appstore.svg'),
  alt: 'Download on AppStore'
})`
  height: 36px;
`;

BottomRow.Texts = styled.div`
  flex: 1;
  margin-left: 30px;
  font-family: Montserrat-Medium, serif;
  font-size: 12px;
  color: #ffffff;
  letter-spacing: 0.12px;
  line-height: 16px;
`;

BottomRow.Container = styled.div`
  align-self: stretch;
  display: flex;
  height: 36px;
  align-items: center;
`;

const imageFor = (emoji: OrderVideoReviewEmoji) => {
  switch (emoji) {
    case OrderVideoReviewEmoji.RollingEyesFace:
      return require('./assets/Rating.svg');
    case OrderVideoReviewEmoji.Sweat:
      return require('./assets/Rating Copy.svg');
    case OrderVideoReviewEmoji.Blush:
      return require('./assets/Rating Copy 2.svg');
    case OrderVideoReviewEmoji.Smile:
      return require('./assets/Rating Copy 3.svg');
    case OrderVideoReviewEmoji.HeartEyes:
      return require('./assets/Rating Copy 4.svg');
  }
};

const ReviewPage = (props: RouteComponentProps<{ reviewId: string }>) => {
  const [state, setState] = useState<null | OrderVideoMessage>(null);
  const reviewId = props.match.params.reviewId;

  useEffect(() => {
    getVideoMessage(reviewId).then(data => {
      setState(data);
    });
  }, [reviewId, setState]);

  if (state == null) {
    return <Container />;
  }

  return (
    <Container>
      <Content>
        <Title>
          PSL
          <br />
          <span style={{ color: 'white' }}>Replay</span>
        </Title>
        <Video controls loop playsInline poster={state.thumbnailURL}>
          <source src={state.videoURL} type="video/mp4" />
        </Video>
        <Reaction emoji={state.emoji || OrderVideoReviewEmoji.Smile} />
        <Note>Watch my video review!</Note>
        <Spacer />
        <BottomRow />
      </Content>
    </Container>
  );
};

export default ReviewPage;
